import Checkbox from 'antd/lib/checkbox'
import { ActionButton } from 'Components/common/ActionButton/ActionButton'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'
import { useMemo, useState } from 'react'
import classes from './PreviewResponse.module.less'

type PreviewResponsePropsType = {
    turn: number
    retryCount: number
    responseValue: string
    onClickRetry: () => void
    isReviewMode?: boolean
}

export const PreviewResponse = (props: PreviewResponsePropsType) => {
    const { turn, retryCount, responseValue, onClickRetry, isReviewMode } = props
    const [isMarkdownEnabled, setIsMarkdownEnabled] = useState(true)

    const response = useMemo(() => {
        if (isMarkdownEnabled) {
            return <MarkdownRenderer children={responseValue} escapeBackslashses={true} />
        } else {
            return <div className={classes.plainText}>{responseValue}</div>
        }
    }, [isMarkdownEnabled, responseValue])

    return (
        <div className={classes.responseContainer}>
            <div className={classes.header}>
                <p className={classes.title}>(Round {turn})</p>
                <Checkbox
                    checked={isMarkdownEnabled}
                    onChange={e => setIsMarkdownEnabled(e.target.checked)}
                    className={classes.checkbox}
                >
                    Enable Markdown
                </Checkbox>

                {!isReviewMode && (
                    <span className={classes.retry}>
                        <ActionButton
                            title={'Retry'}
                            color="default"
                            onClick={onClickRetry}
                            disabled={retryCount >= 3}
                        />{' '}
                        (Max 3 retries allowed)
                    </span>
                )}
            </div>

            <div className={classes.responseValue}>{response}</div>
        </div>
    )
}
